import WidthAndHeightConfig from './WidthAndHeightConfig';
import useCommonStyles from '../../../../../commonStyles';
import PageHeading from '../../../../../Components/PageHeading';
import AspectRatioConfig from './AspectRatioConfig';
//mui imports==========
import { Paper, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
//=====================

const PlayerSizeConfig = ({featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper
			className={commonStyleClasses.mainPagePaperMarginStyle}
			style={{ paddingBottom: '2rem' }}
		>
			<PageHeading
				headingName="Player Sizes"
				headingPath={['Dashboard', 'Framerate', 'FormatData', 'Sizes']}
				description="Manage player size config and  aspect ratio for both incontent and floating mode."
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<AspectRatioConfig keyData="formatData.playerAspectRatio" />
			<PlayerModeSizeConfig keyData="formatData.maxPlayerSizes" label="Incontent Player Size" />
			<PlayerModeSizeConfig keyData="formatData.floatingPlayerSizes" label="Floating Player Size" />
		</Paper>
	);
};

//Size Config ( Renders Width And Height Components for Desktop,Mobile,Tablet )
const PlayerModeSizeConfig = ({ keyData, label }) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Grid
			container
			className={commonStyleClasses.basicOutlinedBox}
			style={{ margin: '4rem auto', width: '95%' }}
		>
			<Grid item xs={12}>
				<Typography variant="h4" style={{ margin: '1.5rem 1.5rem 3rem 1.5rem' }}>
					{label}
				</Typography>
			</Grid>
			<WidthAndHeightConfig keyData={keyData + '.DESKTOP'} deviceType="Desktop" />

			<WidthAndHeightConfig keyData={keyData + '.MOBILE'} deviceType="Mobile" />

			<WidthAndHeightConfig keyData={keyData + '.TABLET'} deviceType="Tablet" />
		</Grid>
	);
};

export default PlayerSizeConfig;
